import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['dropZone', 'fileInput', 'fileInputDetach', 'noImageWrap', 'imageWrap', 'image'];

  connect() {
    this.acceptedTypes = this._acceptedImageTypesFromMeta();
    this.maxFileSize = this._maxImageSizeFromMeta();

    this.dropZoneTarget.addEventListener('dragover', (e) => this.dragover(e));
    this.dropZoneTarget.addEventListener('dragenter', (e) => this.dragover(e));
    this.dropZoneTarget.addEventListener('dragleave', (e) => this.dragleave(e));
    this.dropZoneTarget.addEventListener('dragend', (e) => this.dragleave(e));
    this.dropZoneTarget.addEventListener('drop', (e) => this.drop(e));
    this.fileInputTarget.addEventListener('change', (e) => this.handleFileSelection(e));
  }

  dragover(e) {
    this.dropZoneTarget.classList.add('active');
    e.preventDefault();
    e.stopPropagation();
  }

  dragleave(e) {
    this.dropZoneTarget.classList.remove('active');
    e.preventDefault();
    e.stopPropagation();
  }

  drop(e) {
    const files = e.dataTransfer.files;
    if (files.length && this._validateFile(files[0])) {
      this.fileInputTarget.files = files;
      this.fileInputDetachTarget.value = false;
      this.preview();
    }
    e.preventDefault();
    e.stopPropagation();
  }

  handleFileSelection(e) {
    const file = e.target.files[0];
    if (file && this._validateFile(file)) {
      this.preview();
    } else {
      this.fileInputTarget.value = null;
    }
  }

  edit(e) {
    this.fileInputTarget.click();
    e.stopPropagation();
  }

  delete(e) {
    const result = confirm(this.data.get('deleteConfirm'));
    if (result === true) {
      this.imageWrapTarget.classList.add('d-none');
      this.noImageWrapTarget.classList.remove('d-none');
      this.fileInputTarget.value = null;
      this.fileInputTarget.dispatchEvent(new Event('delete'));
      this.fileInputDetachTarget.value = true;
    }
    e.stopPropagation();
  }

  preview() {
    this.imageTarget.src = URL.createObjectURL(this.fileInputTarget.files[0]);
    this.imageWrapTarget.classList.remove('d-none');
    this.noImageWrapTarget.classList.add('d-none');

    const invalidIndicator = this.element.closest('.is-invalid');
    if (invalidIndicator) {
      invalidIndicator.classList.remove('is-invalid');
    }
  }

  _validateFile(file) {
    if (!this.acceptedTypes.includes(file.type)) {
      alert("Ongeldig bestandstype. Alleen afbeeldingen (JPEG, PNG, GIF) zijn toegestaan.");
      return false;
    }

    if (file.size > this.maxFileSize) {
      alert("Bestand is te groot. Maximale grootte is 5 MB.");
      return false;
    }

    return true;
  }

  _acceptedImageTypesFromMeta() {
    const meta = document.querySelector('meta[name="accepted-image-types"]');
    return meta?.content?.split(',') || ['image/jpeg', 'image/png'];
  }

  _maxImageSizeFromMeta() {
    const meta = document.querySelector('meta[name="max-image-size"]');
    return parseInt(meta?.content || '5242880', 10); // default to 5 MB
  }
}
